export class ProfileInfoModalRequest {
    TransactionId: string;
}
export class ProfileInfo {
    CompanyId: string;
    CompanyName: string;
    IsQVAdminUser: boolean;
    IsQVUser: boolean;
    LoggedInUserId: string;
    loggedInUUID: string;
    TargetUserId: string;
    TargetUUID: string;
    IsCVUser: boolean;
    IsCVAdmin: boolean;
}
export class AccountEligibilityRequest {
    TransactionId: string;
    EligibleType: string;
    FlowType: string;
    Locale: Locale_AM;
}


export class UPPLMResponseModal {
    ErrorCode: string;
    ErrorDescription: string;
    ErrorType: string;   
    IsError: boolean;
    IsValid: boolean;
    ProfileResponseObj: any;
    ResponseObject: any;
    TransactionId: string;
    IS_PROD: boolean;
    IsCreateInboundFlow: boolean;
    IsCreateOutboundFlow: boolean;
    IsCreateCompanySuccess: boolean;
    HasSessionData: boolean;
    SessionObj: any;
    CreateCompanyObj: any;
}

export class GetAccountDetailsRequest {
    TransactionId: string;
    Locale: Locale_AM;
    AccountInfo: AccountInfo_AM;
}
export class Locale_AM {
    LanguageCode: string;
    CountryCode: string;
}
export class AccountInfo_AM {
    AccountNumber: string;
    CountryCode: string;
}
export class CreateCVAPPSessionObject {
    IsValid: boolean;
    HasSessionData: boolean;
    SessionResponse: any;
    CVSessionModal: CVSessionModal;
}
export class CVSessionModal {
    ShouldCreateCompany: string;
    FlowType: string;
    CompanyName: string;
    AccountNumber: string;
    AccountPostalCode: string;
    AccountCountryCode: string;
    WebPageCountryCode: string;
    Iobb: string;
    DOAppTransactionID: string;    
    AccountName: string;
    DOAStatus: string;
    UserID: string;
    UserName: string;
    Email: string;
    PickUp: any;
}

export class Error {
    message?: string;
    code?: string;
    Url?: string;
    Source?: string;
}